<template>
    <div class="homeTempPage">
        <header-integration style="position: absolute;z-index: 4" :headerIntegration="headerIntegration"></header-integration>
        <div class="leftShow">
            <plate-title style="left: 8px" title="项目概况"></plate-title>
            <project-overview :projectOverview="projectOverview"></project-overview>
            <plate-title style="left: 8px;bottom: 1vh" title="人员管理"></plate-title>
            <div id="line" class="line"></div>
            <plate-title style="left: 8px;top: 1vh" title="人员进出场"></plate-title>
            <person-enter-and-exit style="left: 8px;top: 1.3vh"></person-enter-and-exit>
        </div>
        <div class="rightShow">
            <plate-title style="right: 8px" title="环境监测"></plate-title>
            <environment-monitor :environmentMonitor="environmentMonitor"></environment-monitor>
            <plate-title style="left: 3.125vw;bottom: 1vh" title="安全质量巡查"></plate-title>
            <div id="column" class="column"></div>
            <plate-title style="left: 2.3vw;top: 1vh" title="视频监控"></plate-title>
            <video-monitor style="width: 25.54vw;left: 3vw;top: 1.3vh"></video-monitor>
        </div>
        <panorama :downEvent="downEvent" :moveEvent="moveEvent" :wheelEvent="wheelEvent"></panorama>
        <icons-group style="position: absolute;left: 38.54vw;bottom: 5.65vh;z-index: 3"></icons-group>
        <div class="background"></div>
        <div class="showArea" ref="showArea"></div>
    </div>
</template>

<script>
import Highcharts from 'highcharts';
import headerIntegration from './components/headerIntegration.vue';
import plateTitle from './components/plateTitle.vue';
import projectOverview from './components/projectOverview.vue';
import personEnterAndExit from './components/personEnterAndExit.vue';
import environmentMonitor from './components/environmentMonitor.vue';
import videoMonitor from './components/videoMonitor.vue';
import panorama from './components/panorama.vue';
import iconsGroup from './components/iconsGroup.vue';

export default {
    components: {
        headerIntegration,
        plateTitle,
        projectOverview,
        personEnterAndExit,
        environmentMonitor,
        panorama,
        videoMonitor,
        iconsGroup,
    },

    data() {
        return {
            headerIntegration: {
                title: '蚌埠医学院第一附属医院心脑血管中心施工总承包项目',
                secondTitle: '项目现场管理系统',
            },
            projectOverview: {
                constructionUnit: '中建八局第三建设有限公司',
                EPCGeneralContractingUnit: '中国建筑第八工程有限公司',
                designUnit: '机械工业勘察设计研究院有限公司',
                supervisionUnit: '上海同济工程项目管理咨询有限公司',
                conTractPeriod: '365天',
                countdownToCompletion: '145天',
            },
            environmentMonitor: {
                location: "蚌埠",
                weather: "阴天",
                typeDetails: [
                    { typeName: "风速", value: "2.5", unit: "m/s"},
                    { typeName: "风速", value: "2.5", unit: "m/s"},
                    { typeName: "风速", value: "2.5", unit: "m/s"},
                    { typeName: "风速", value: "2.5", unit: "m/s"},
                    { typeName: "风速", value: "2.5", unit: "m/s"},
                    { typeName: "风速", value: "2.5", unit: "m/s"},
                ],
            },
            element: undefined,
            downEvent: undefined,
            moveEvent: undefined,
            wheelEvent: undefined,
        }
    },

    mounted() {
        this.peopleManLine();
        this.safeAndQuaInsCol();
        this.controlPanorama();
    },

    computed: {
        showArea: {
            cache: false,
            get() {
                return this.$refs.showArea
            }
        }
    },

    methods: {
        peopleManLine() {
            Highcharts.chart('line', {
                chart: { type: 'line', spacing: [5, 5, 0, -50], backgroundColor: 'transparent' },
                title: { text: '' },
                colors: ['#FFFFFF', '#1051CE', '#F8D808'],
                xAxis: {
                    categories: ['02:00', '02:01', '02:02', '02:03', '02:04', '02:05', '02:06'],
                    labels: { style: { color: '#01FFFF' } },
                },
                yAxis: {
                    lineWidth: 1,
                    title: { text: '单位/人', align: 'high', rotation: 0, x: 70, y: -10, style: { color: '#ffffff' } },
                    labels: { x: -5, style: { color: '#ffffff' } },
                },
                legend: { align: 'right', verticalAlign: 'top', itemStyle: { color: '#ffffff' } },
                tooltip: { shared: true, useHTML: true },
                series: [
                    { name: '管理人员', data: [150, 160, 150, 155, 140, 150, 160] },
                    { name: '特种人员', data: [250, 260, 250, 255, 240, 250, 260] },
                    { name: '工人', data: [350, 360, 350, 355, 340, 350, 360] }
                ],
            })
        },
        safeAndQuaInsCol() {
            Highcharts.chart('column', {
                chart: { type: 'column', spacing: [30, 30, -25, -60], backgroundColor: 'transparent' },
                title: { text: '' },
                xAxis: {
                    title: { text: '类型', align: 'high', x: 25, y: -80, style: { color: '#ffffff' } },
                    categories: ['累计检查数量', '已处理', '未处理', '本月检查', '本周检查'],
                    labels: { style: { color: '#ffffff' } },
                },
                yAxis: {
                    lineWidth: 1,
                    title: { text: '单位/次数', align: 'high', rotation: 0, x: 80, y: -10, style: { color: '#ffffff' } },
                    labels: { x: -5, style: { color: '#ffffff' } },
                },
                legend: { enabled: false },
                tooltip: { useHTML: true },
                series: [
                    {
                        name: '',
                        data: [109, 80, 35, 21, 5],
                        colorByPoint: true,
                    }
                ],
            }, chart => this.setEveryOnePointColor(chart))
        },
        setEveryOnePointColor(chart) {
            const pointsList = chart.series[0].points;
            const colors = ['#0BF2FA', '#008CFF', '#FF0000', '#060AFA', '#07B5FA'];
            for (let i = 0; i < pointsList.length; i++) {
                chart.series[0].points[i].update({
                    color: {
                        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                        stops: [ { 0: 0, 1: colors[i] }, { 0: 1, 1: 'transparent' } ],
                    }
                })
            }
        },

        controlPanorama() {
            this.element = document.getElementsByClassName('showArea')[0];
            this.element.addEventListener('mousedown', this.onMouseDown);
            this.element.addEventListener('wheel', this.onMouseWheel);
        },
        onMouseDown(event) {
            event.preventDefault();
            if (event.button === 0) {
                this.downEvent = { clientX: event.clientX, clientY: event.clientY };
                this.element.addEventListener('mousemove', this.onMouseMove);
                this.element.addEventListener('mouseup', this.onMouseUp);
            };
        },
        onMouseMove(event) {
            if (event) {
                event.preventDefault();
                this.moveEvent = { clientX: event.clientX, clientY: event.clientY };
            }
        },
        onMouseUp() {
            this.element.removeEventListener('mousemove', this.onMouseMove);
            this.element.removeEventListener('mouseup', this.onMouseUp);
        },
        onMouseWheel(event) {
            event.preventDefault();
		    event.stopPropagation();
            this.wheelEvent = { deltaY: event.deltaY };
        },
    }
}
</script>

<style lang="less">
.homeTempPage {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: -9.3vh;
    z-index: 1;
    overflow: hidden;
    font-family: PingFang SC;
    display: flex;
    justify-content: center;
}

.leftShow {
    position: absolute;
    left: 0px;
    top: 8vh;
    z-index: 1;
    .line {
        left: 16px;
        width: 22.81vw;
        height: 22.87vh;
    }
}

.rightShow {
    position: absolute;
    right: 0px;
    top: 8vh;
    z-index: 1;
    .column {
        left: 3.125vw;
        width: 22.81vw;
        height: 22.87vh;
    }
}

.panorama {
    width: 100vw;
    height: 100vh;
}

.background {
    .panorama();
    position: absolute;
    top: 0;
    background: url('../../../assets/image/homeTemp/background.png');
    background-size: 100% 100%;
}

.showArea {
    position: absolute;
    top: 6.02vh;
    width: 49.48vw;
    height: 87.96vh;
    border-radius: 960px;
    z-index: 2;
    background: url('../../../assets/image/homeTemp/showArea.png');
    background-size: 100% 100%;
}
</style>
